import { LGraphNode } from "../../litegraph/js/litegraph";

class ToolsNodes extends LGraphNode {
    static title = "Tools";
    static size = [300, 60];

    constructor() {
        super();
        this.title = "Wished Tool";
        this.addOutput("", "string");
        this.addInput("", "string");
    }

    onExecute() {
        this.setOutputData(0, "");
    }
}

class ToolsMainNodes extends LGraphNode {
    static title = "Tools";
    constructor() {
        super();
        this.title = "Capabilities (Tools)";
        this.addOutput("Output", "string");
        this.properties = {
            Tools: ""
        };
    }

    onExecute() {
        this.setOutputData(0, "");
    }
}

class CellNode extends LGraphNode {
    static title = "Reasoning Handler";
    constructor() {
        super();
        this.title = "Reasoning Handler";
        this.addInput(`Encoder Input`, "string");
        this.addInput(`Capabilities Input`, "string");
        this.addInput(`Memory Input`, "string");
        this.addInput(`Agency Input`, "string");
        this.addInput(`Pathways Input`, "string");

        this.addOutput("Output", "string");
        // this.properties = {
        //     "Choose Output Message": ""
        // };

        this.properties = {
            Goal: "",
            Analysis: ""
        };

        // this.combo = this.addWidget("combo", "Nucleus", "", function (v) {}, {
        //     values: [],
        // });
    }

    onExecute() {
        this.setOutputData(0, "");
    }
}

class InitializationNode extends LGraphNode {
    static title = "Initializer";
    constructor() {
        super();
        this.title = "Initializer";
        //add some output slots
        this.addOutput("Output", "string");
        //add some properties
        this.properties = { precision: 1 };
    }

    onExecute() {
        //retrieve data from inputs
        this.setOutputData(0, "");
    }
}

/**
 * Cellular Encoder
 */
class CellularEncoderNode extends LGraphNode {
    static title = "Cellular Encoder";
    constructor() {
        super();
        this.title = "Cellular Encoder";
        this.addInput("", "string");
        this.addInput("", "string");
        //add some output slots
        this.addOutput("Output", "string");
    }

    onExecute() {
        //retrieve data from inputs
        this.setOutputData(0, "");
    }
}

/**
 * Memory Node
 */
class MemoriesNode extends LGraphNode {
    static title = "Memory (Data)";
    constructor() {
        super();
        //add some output slots
        this.title = "Memory (Data)";
        this.addOutput("Output", "string");

        this.addWidget("combo", "Memories", "", () => {}, {
            values: ["All"]
        });
    }

    onExecute() {
        //retrieve data from inputs
        this.setOutputData(0, "");
    }
}

/**
 * Prompt Node
 */
class PromptNode extends LGraphNode {
    static title = "Agency";
    constructor() {
        super();
        this.title = "Agency";
        //add some output slots
        this.addOutput("Output", "string");

        this.addWidget("combo", "Prompts", "", () => {}, {
            values: ["None"]
        });
    }

    onExecute() {
        //retrieve data from inputs
        this.setOutputData(0, "");
    }
}

/**
 * Pathways Node
 */
class PathwaysNode extends LGraphNode {
    static title = "Pathways (Prompt)";
    constructor() {
        super();
        this.title = "Pathways (Prompt)";
        //add some output slots
        this.addOutput("Output", "string");

        this.addWidget("combo", "Pathways", "", () => {}, {
            values: ["Open AI 3.5", "Open AI 4"]
        });
    }

    onExecute() {
        //retrieve data from inputs
        this.setOutputData(0, "");
    }
}

/**
 * Cell breaker Node
 */
class CellBreakerNode extends LGraphNode {
    static title = "Connector";
    constructor() {
        super();
        this.title = "Connector";
        // add input
        this.addInput("", "string");
        //add some output slots
        this.addOutput("Loop", "string");
        this.addOutput("Foward", "string");
        this.addOutput("Extra", "string");
    }

    onExecute() {
        //retrieve data from inputs
        this.setOutputData(0, "");
    }
}

class PerceptorInputNode extends LGraphNode {
    static title = "Perceptor";
    constructor() {
        super();
        this.title = "Perceptor";
        // this.addInput("", "string");
        // this.addInput("", "string");
        //add some output slots
        this.addOutput("", "string");
    }

    onExecute() {
        //retrieve data from inputs
        this.setOutputData(0, "");
    }
}
class ActivatorNode extends LGraphNode {
    static title = "Activator";
    constructor() {
        super();
        this.title = "Activator";
        this.addInput("", "string");
        // this.addInput("", "string");
        //add some output slots
        // this.addOutput("", "string");
    }

    onExecute() {
        //retrieve data from inputs
        this.setOutputData(0, "");
    }
}

class AgencyToolNode extends LGraphNode {
    static title = "Agency Tool";
    static size = [300, 45];

    constructor() {
        super();
        this.title = "Agency Tool";
        this.addOutput("", "string");
        this.addInput("", "string");
    }

    onExecute() {
        this.setOutputData(0, "");
    }
}

class RigidAppToolNode extends LGraphNode {
    static title = "Rigid App Tool";
    static size = [300, 45];

    constructor() {
        super();
        this.title = "Rigid App Tool";
        this.addOutput("", "string");
        this.addInput("", "string");
    }

    onExecute() {
        this.setOutputData(0, "");
    }
}

export function cellSetup(LiteGraph) {
    LiteGraph.clearRegisteredTypes();

    LiteGraph.registerNodeType("Main/ToolsNode", ToolsMainNodes);

    LiteGraph.registerNodeType("Main/NucleusNode", CellNode);

    //register in the system
    LiteGraph.registerNodeType("Main/InitializerNode", InitializationNode);

    //register in the system
    LiteGraph.registerNodeType("Main/CellularEncoderNode", CellularEncoderNode);

    //register in the system
    LiteGraph.registerNodeType("Main/MemoriesNode", MemoriesNode);

    //register in the system
    LiteGraph.registerNodeType("Main/PromptsNode", PromptNode);

    //register in the system
    LiteGraph.registerNodeType("Main/PathwaysNode", PathwaysNode);

    //register in the system
    LiteGraph.registerNodeType("Main/CellBreakerNode", CellBreakerNode);
}

export function cellsSetupTools(LiteGraph) {
    LiteGraph.clearRegisteredTypes();

    LiteGraph.registerNodeType("Capabilities/ToolsNode", ToolsNodes);

    // register perceptor in system
    LiteGraph.registerNodeType("Main/PerceptorInputNode", PerceptorInputNode);

    // register agency tool in system
    LiteGraph.registerNodeType("Main/AgencyToolNode", AgencyToolNode);

    // register agency tool in system
    LiteGraph.registerNodeType("Main/RigidAppToolNode", RigidAppToolNode);

    // register ActivatorNode in system
    LiteGraph.registerNodeType("Main/ActivatorNode", ActivatorNode);
}
